import { getVersion } from '../api/version';

const ADD_API_VERSION = 'ADD_API_VERSION';

export default function reducer(state = '', action) {
  switch (action.type) {
    case ADD_API_VERSION:
      return action.payload;
    default:
      return state;
  }
}

export function getApiVersionNumber() {
  return async (dispatch) => {
    try {
      const version = await getVersion();

      dispatch({
        type: ADD_API_VERSION,
        payload: version,
      });

      return Promise.resolve(version);
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
